/**
 *  PhysicsActor
 *
 *  Created by Legman on 22/02/2017.
 *
 */

import Actor    from "./Actor";
import Common   from "./Common";

/**
 * @class
 */
export default class PhysicsActor extends Actor {
    /**
     * @param {PIXI.Texture} [texture]
     */
    constructor(texture) {
        super(texture);

        /**
         * @member {boolean}
         */
        this.syncToBody = true;

        /**
         * @member {boolean}
         * @private
         */
        this._hit = false;

        this.body = this.createBody();
        if (this.body) {
            this.body.parent = this;
            this.body.updateMassProperties();
            Common.world.addBody(this.body);
        }
    }

    init() {
        super.init();

        if (this.body) {
            this.body.position = [this.x, this.y];
            this.body.angle = this.rotation;
        }
    }

    /**
     * @param {boolean} [destroyChildren]
     */
    destroy(destroyChildren) {
        this.body && (Common.world.removeBody(this.body));

        super.destroy();
    }

    /**
     * @returns {p2.Body}
     */
    createBody() {
        return null;
    }

    update() {
        super.update();

        this.body && this.synchronizePhysics();
    }

    synchronizePhysics() {
        if (this.syncToBody) {
            this.x = this.body.position[0];
            this.y = this.body.position[1];
            this.rotation = this.body.angle;
        } else {
            this.body.position[0] = this.x;
            this.body.position[1] = this.y;
            this.body.angle = this.rotation;
        }
    }

    /**
     * @param {p2.Body} [body]
     */
    onBeginContact(body) {
        this._hit = true;
    }

    /**
     * @param {p2.Body} [body]
     */
    onEndContact(body) {
        this._hit = false;
    }

    /**
     * @returns {boolean}
     */
    get hit() {
        return this._hit;
    }
}

/**
 * @static
 * @const
 * @type {number}
 */
PhysicsActor.DEFAULT = Math.pow(2, 0);

/**
 * @static
 * @const
 * @type {number}
 */
PhysicsActor.GUMMY_BEAR = Math.pow(2, 1);

/**
 * @static
 * @const
 * @type {p2.Material}
 */
PhysicsActor.MATERIAL_DEFAULT = new p2.Material();

/**
 * @static
 * @const
 * @type {p2.Material}
 */
PhysicsActor.MATERIAL_GUMMY_BEAR = new p2.Material();
